module.exports = __webpack_public_path__ + "static/media/favicon-jetro817.8cf61ca9.ico";